"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfIM = exports.PdfVM = void 0;
const pdfs_1 = require("../core-model-schemas/pdfs");
exports.PdfVM = pdfs_1.PdfsSchema;
exports.PdfIM = pdfs_1.PdfsSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
